import { render, staticRenderFns } from "./myPurchases.vue?vue&type=template&id=5c4c5bc0&scoped=true&lang=html&"
import script from "./myPurchases.vue?vue&type=script&lang=js&"
export * from "./myPurchases.vue?vue&type=script&lang=js&"
import style0 from "./myPurchases.vue?vue&type=style&index=0&id=5c4c5bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4c5bc0",
  null
  
)

export default component.exports